import { useNavigate } from 'react-router-dom'
import {
	Box,
	Card,
	CardContent,
	Typography,
	Button,
	Alert,
	List,
	ListItem,
	ListItemText,
} from '@mui/material'
import { Warning } from '@mui/icons-material'
import { useAuth } from '../contexts/auth-context'

export function NoCompanyAssigned() {
	const { user, signOut } = useAuth()
	const navigate = useNavigate()

	// Auth is handled by AuthGuard in App.jsx
	return (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			minHeight="70vh"
			maxWidth="md"
			margin="auto"
			mt={6}
		>
			<Card
				elevation={4}
				sx={{
					borderRadius: 3,
					px: 4,
					py: 6,
					width: '100%',
					textAlign: 'center',
				}}
			>
				<CardContent>
					<Warning sx={{ fontSize: 64, color: 'warning.main', mb: 2 }} />
					<Typography variant="h4" fontWeight="bold" gutterBottom>
						Company Assignment Required
					</Typography>
					<Typography variant="body1" color="text.secondary" mb={3}>
						Your account (<strong>{user?.email}</strong>) is not currently assigned to a company.
					</Typography>
					<Typography variant="body2" color="text.secondary" mb={4}>
						Please contact your administrator to assign your account to a company. 
						You will need company access to view sensor data.
					</Typography>
					
					<Alert severity="info" sx={{ textAlign: 'left', mb: 3 }}>
						<Typography variant="subtitle2" fontWeight="600" gutterBottom>
							What to do next:
						</Typography>
						<List dense>
							<ListItem>
								<ListItemText primary="Contact your Aquatic Labs administrator" />
							</ListItem>
							<ListItem>
								<ListItemText 
									primary={
										<>
											Provide your email address: <code style={{ 
												backgroundColor: 'rgba(0, 0, 0, 0.1)', 
												padding: '2px 6px', 
												borderRadius: '4px',
												fontFamily: 'monospace'
											}}>{user?.email}</code>
										</>
									} 
								/>
							</ListItem>
							<ListItem>
								<ListItemText primary="Request assignment to your company" />
							</ListItem>
						</List>
					</Alert>
					
					<Box display="flex" gap={2} justifyContent="center">
						<Button
							variant="outlined"
							onClick={() => navigate('/')}
						>
							Back to Home
						</Button>
						<Button
							variant="contained"
							onClick={signOut}
						>
							Sign Out
						</Button>
					</Box>
				</CardContent>
			</Card>
		</Box>
	)
}
